import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';

import { INTERACTIVE_STATES, SIZE_SCALE } from '@/components/design-system/tokens';
import { cn } from '@/lib/utils';

type SwitchProps = React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>;

const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, SwitchProps>(
  ({ className, ...props }, ref) => (
    <SwitchPrimitives.Root
      className={cn(
        `peer inline-flex ${SIZE_SCALE['5']} ${SIZE_SCALE.w9} shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors`,
        INTERACTIVE_STATES.duration.normal,
        INTERACTIVE_STATES.focus.outline,
        INTERACTIVE_STATES.focus.ring,
        INTERACTIVE_STATES.focus.offset,
        INTERACTIVE_STATES.disabled.cursor,
        INTERACTIVE_STATES.disabled.opacity,
        'data-[state=checked]:bg-primary data-[state=unchecked]:bg-input',
        className
      )}
      {...props}
      ref={ref}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          `pointer-events-none block ${SIZE_SCALE['4']} ${SIZE_SCALE.w4} rounded-full bg-background shadow-lg ring-0 transition-transform`,
          INTERACTIVE_STATES.duration.normal,
          'data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0'
        )}
      />
    </SwitchPrimitives.Root>
  )
);
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
